import React from 'react';
import { Alert } from 'reactstrap';
import i18next from 'i18next';

import { YesNoIcons } from '../icons/IconSets';
import Shapes from 'shapes/main';
import { NormalizedRestaurant, OrdersConfig } from 'types';

interface IProps {
  ordersConfig: OrdersConfig;
  restaurant: NormalizedRestaurant;
}

const OrdersConfigNotFinishedAlert: React.FC<IProps> = ({
  ordersConfig,
  restaurant,
}) => {
  return (
    <>
      <Alert color="info">
        <div>
          {i18next.t('orders-config-not-finished-alert.no-online-orders')}
        </div>
        <div>
          <a href="/settings/orders">{i18next.t('orders-config-not-finished-alert.configure-link-text')}</a>
          {i18next.t('orders-config-not-finished-alert.configure-link-suffix')}{' '}
          <a href="/help">{i18next.t('orders-config-not-finished-alert.contact-link-text')}</a>
        </div>
      </Alert>
      <div className="mt-2">{i18next.t('orders-config-not-finished-alert.required-fields')}</div>
      <ul className="list-unstyled">
        {[
          {
            label: i18next.t('orders-config-not-finished-alert.delivery-settings'),
            present: !!ordersConfig?.delivery,
          },
          {
            label: i18next.t('orders-config-not-finished-alert.opening-hours'),
            present: !!restaurant.delivery_opening_hours,
          },
          {
            label: i18next.t('orders-config-not-finished-alert.delivery-time'),
            present: !!ordersConfig?.deliveryTime,
          },
          {
            label: i18next.t('orders-config-not-finished-alert.delivery-zones'),
            present:
              !!ordersConfig?.delivery?.area &&
              !!ordersConfig?.delivery?.areaOptions,
          },
        ].map((field) => (
          <li key={field.label} className="mt-1">
            {field.present ? YesNoIcons.YES : YesNoIcons.NO} {field.label}
          </li>
        ))}
      </ul>
    </>
  );
};

OrdersConfigNotFinishedAlert.propTypes = {
  ordersConfig: Shapes.ordersConfigShape.isRequired,
  restaurant: Shapes.restaurantShape.isRequired,
};

export default OrdersConfigNotFinishedAlert;
